export const announcementsData = [
  {
    Key: 1,
    Date: "22 Aug 2025, 05:40 PM",
    Announcements: "Welcome to Introduction to Programming",
    AnnouncementsKey: "Course: Introduction to Programming - Python & Java",
    Status: "Published",
  },
  {
    Key: 2,
    Date: "10 Aug 2025, 10:15 AM",
    Announcements: "Essay Assignment Due Date Approaching",
    AnnouncementsKey:
      "Course: Sketch from A to Z (2024): Become an app designer",
    Status: "Draft",
  },
  {
    Key: 3,
    Date: "26 Jul 2025, 01:30 PM",
    Announcements: "Final Exam Schedule and Preparation Tips",
    AnnouncementsKey: "Course: Learn Angular Fundamentals Beginners Guide",
    Status: "Published",
  },
  {
    Key: 4,
    Date: "15 May 2025, 04:00 PM",
    Announcements: "New Video Lectures Added",
    AnnouncementsKey:
      "Course: Learn JavaScript and Express to become an Expert",
    Status: "Published",
  },
];
